import Service from './Service';

export default class Banner extends Service {

  listByGroup() {
    return this.axiosInstance.get(`/banners/group`);
  }

  listByCompany() {
    return this.axiosInstance.get(`/banners/company`);
  }

  listAllByCompany() {
    return this.axiosInstance.get(`/banners/all`);
  }
}